import React from "react";
import PropTypes from "prop-types";
import { BookStore, BookUtils, Dispatcher } from "../../flux";
import {
  FilterAndSortBar,
  FindField,
  StickyList,
  SectionHeader,
  Isvg,
  Menu,
  MenuMixin,
  MenuList,
  MenuHeader,
  Spinner
} from "../../components";

class Demo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  componentDidUpdate() {}

  render() {
    const book = BookStore.get(this.props.isbn);
    return (
      <div>
        <div>{book.title}</div>
        <div>{book.author}</div>
        <div>{book.isbn}</div>
      </div>
    );
  }
}

Demo.propTypes = {
  isbn: PropTypes.string.isRequired
};

Demo.defaultProps = {};

const gadgetId = "demo";
module.exports = {
  class: Demo,
  metadata: () => {
    return {
      id: gadgetId,
      enabled: () => false, // change this true for demo purposes!
      name: "Demo",
      type: "panel",
      sidebar: {
        icon: "/img/demo/assets/demo.svg",
        action: isbn => Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId)
      }
    };
  }
};
